import { formatAbsolute } from '../lib/format'
import type { useChatActivity } from '../hooks/useChatActivity'

const countFormat = new Intl.NumberFormat()
const percentageFormat = new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 })

export function ChatActivityStatus({ activity }: { activity: ReturnType<typeof useChatActivity> }) {
  const { configured, data, loading, error, reload } = activity
  const availableCount = data?.samples.filter((sample) => sample.messagesPerSecond !== null).length ?? 0
  const coverage = data ? data.coverage.available.reduce((total, interval) => total + interval.to - interval.from, 0) / (data.to - data.from) * 100 : 0

  return (
    <section className="timeline-activity-status" aria-label="DGG chat activity" aria-busy={loading}>
      <div className="timeline-activity-summary" role="status">
        <strong>DGG chat activity</strong>
        <span className="timeline-activity-unit">msg/s · 1-minute average</span>
        {!configured && !error ? (
          <span>Not connected. Set <code>VITE_CHAT_ACTIVITY_API_URL</code> to connect the metrics Worker.</span>
        ) : (
          <>
            {loading && <span>{data ? 'Updating activity…' : 'Loading activity…'}</span>}
            {error && <span>{error}.{data ? ' Showing previously loaded data.' : ' VOD browsing is still available.'}</span>}
            {data && (
              <>
                <span>{availableCount > 0
                  ? `${countFormat.format(availableCount)} available samples · ${percentageFormat.format(coverage)}% of this window covered`
                  : 'No activity data available for this time window.'}</span>
                {data.latestSampleAt !== null && <span>Latest sample: {formatAbsolute(data.latestSampleAt)}{data.stale ? ' · Delayed' : ''}</span>}
                {data.lastSuccessfulCollectionAt !== null && <span>Last collected: {formatAbsolute(data.lastSuccessfulCollectionAt)}</span>}
              </>
            )}
            {configured && <span className="timeline-activity-note">Collection every 5 minutes{data?.coverage.gaps.length ? ' · Striped areas: no data' : ''}</span>}
          </>
        )}
      </div>
      {configured && error && <button className="btn" onClick={reload} disabled={loading}>Retry activity</button>}
    </section>
  )
}
